export const habaCommon = {
  pageHero: {
    sideTitle: 'Auf dieser Seite',
  },
  breadcrumbs: {
    home: 'Start',
    shop: 'Shop',
  },
  habaSearch: {
    home: 'Home',
    productsAndShop: 'Produkte & Shop',
    placeholder: 'Suche nach Produkten, Ratgebern oder Services',
    searchSuggestions: 'Suchvorschläge',
    brandSuggestions: 'Marken',
    categorySuggestions: 'Kategorien',
    productSuggestions: 'Produkte',
    noSuggestions: 'Keine Ergebnisse.',
    noProductSuggestions: 'Für Ihre Suche gibt es keine Produktübereinstimmungen.',
    viewAll: 'Alle anzeigen ({{ number }})',
    contentPages: 'Inhaltsseiten',
    servicesAndBenefits: 'Services & Vorteile',
    faq: 'Häufig gestellte Fragen',
    more: 'Mehr',
    filter: 'Filter',
    filterButton: 'Filtern',
    filterAndSort: 'Filtern & Sortieren',
    categories: 'Weitere Kategorien',
    filters: {
      age: 'Alter',
      color: 'Farbe',
      brand: 'Marke',
      sortBy: 'Sortieren nach',
      showNewArrivals: 'Neu im Shop',
      categories: 'Kategorien',
      campaignTags: 'Kampagne',
      newArrivals: 'Neuheiten',
      more: 'Mehr Filter',
      price: 'Preis',
      suitableFor: 'Geeignet für',
      size: 'Grösse',
      ageGroups: 'Alter',
      ageRange: 'Alter',
      productFunctions: 'Funktion',
      productFeatures: 'Eigenschaft',
      productSeries: 'Produktreihe',
      materials: 'Material',
      sort: 'Sortieren',
      sortedBy: 'Sortiert nach',
      sortSub: {
        mostPopular: 'Relevanz',
        new: 'Neuheiten',
        priceAsc: 'Preis (niedrigster zuerst)',
        priceDesc: 'Preis (höchster zuerst)',
        nameAsc: 'Name (absteigend)',
        nameDesc: 'Name (aufsteigend)',
      },
      reviews: 'Bewertung',
      show: 'Anzeigen',
      filter: 'Filtern',
      resetAll: 'Alle zurücksetzen',
      reset: 'zurücksetzen',
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger anzeigen',
      salesFilter: 'Nur Sonderangebote',
      specialPrice: 'Sonderangebote',
    },
    noResults: {
      showAllProducts: 'Mehr anzeigen',
      suggestions: 'Suchen Sie danach?',
      title: 'Hmmm...',
      messageFirstPart: 'Wir konnten keine Ergebnisse für <b>„{{ query }}“</b> finden.',
      messageSecondPart:
        'Überprüfen Sie Ihre Suche noch einmal auf Tipp- oder Rechtschreibfehler- oder versuchen Sie es mit einem anderen Suchbegriff.',
    },
    recommendations: {
      similarProducts: 'Ähnliche Produkte',
      matchingProducts: 'Passende Produkte',
    },
  },
  habaNavigation: {
    showAll: 'Alles anzeigen',
    more: 'Mehr',
    back: 'zurück',
    allProducts: 'Alle Produkte',
    topLinks: {
      directOrders: 'Direktbestellung',
      contact: 'Kontakt',
      ociSession: 'PUNCHOUT',
    },
    countrySelection: 'LÄNDERAUSWAHL',
    germany: 'Deutschland',
    austria: 'Österreich',
  },
  habaHttpHandlers: {
    code: {
      alreadyRedeemed: 'Der Gutschein wurde bereits hinzugefügt.',
      maxApplied: 'Es können maximal 3 Gutscheine mit einer Bestellung eingelöst werden.',
      expired: 'Dieser Code ist bereits abgelaufen.',
      unknownException: 'Die Gutscheinnummer ist nicht gültig.',
      invalidCodeProvided: 'Dieser Code ist ungültig.',
      giftcardCommunicationError: 'Kommunikationsfehler mit S/4!',
      giftcardErrorS4NotAvailable:
        'Leider können Vorteilscodes derzeit aus technischen Gründen nicht eingelöst werden. Bitte wenden Sie sich an unseren Kundenservice.',
      giftcardRedemptionNotAllowed: "Gutscheine können mit der Zahlungsart nicht eingelöst werden",
      giftcardInvalidBusinessModel: 'Ungültiges Geschäftsmodell {{ additionalMessage }}',
      giftcardInvalidBrand: 'Ungültige Marke {{ additionalMessage }}',
      giftcardInvalidCurrency: 'Ungültige Währung {{ additionalMessage }}',
      giftcardAmount: 'Der Restbetrag auf der Geschenkkarte beträgt 0',
      giftcardInvalid:
        'Die Geschenkkarte ist nicht gültig - sie ist am {{ additionalMessage }} abgelaufen.',
      purchaseGiftcards:
        'Dieses Zahlungsmittel kann nicht für den Kauf von Wertgutscheinen verwendet werden',
      badRequest:
        'Leider ist die Änderung nicht möglich. Geben Sie bitte eine andere E-Mail-Adresse an.',
      billingAddressNotSet: 'Bitte geben Sie Ihre Rechnungsadresse',
      deliveryAddressNotSet: 'Bitte geben Sie Ihre Lieferadresse',
      deliveryAddressSet: 'Sie haben Ihre Zahlart geändert.',
      billingAddressSet: 'Du hast deine Rechnungsadresse geändert.',
      paymentMethodSet: 'Du hast deine Zahlungsart geändert.',
    },
    notAvailable: 'Seite nicht erreichbar',
    registration: {
      success: 'Ihre Registrierung war erfolgreich.',
      tokenExpired: 'Token abgelaufen',
      invalidToken: 'Ungültiges Token',
      notSpecific: 'Ein unerwarteter Fehler ist aufgetreten.',
      customerNotFound: 'Kunde nicht gefunden',
    },
    featureNotAvailable:
      'Diese Funktion steht aus technischen Gründen derzeit nicht zur Verfügung. Bitte wenden Sie sich an unseren Kundenservice.',
  },
  habaAuthentication: {
    success: 'Authentifizierung erfolgreich',
    ociAuthenticationFailed:
      'Ein Fehler ist aufgetreten, während versucht wurde, die Sitzung zu erstellen. Bitte versuchen Sie es erneut.',
  },
  habaFooter: {
    contact: {
      retour: {
        headline: 'Retouren- & Widerrufsformular',
        description: 'Sie möchten eine Bestellung widerrufen oder Artikel retournieren?',
        button: 'Bestellung widerrufen',
      },
    },
    info: {
      infoService: 'Infoservice',
      schedule: 'Montag bis Freitag von 8-16 Uhr',
      infoServiceTelephone: {
        DE: '0800-8827773',
        AT: '0800-8809407',
      },
      infoServiceEmail: 'kontakt@wehrfritz.com',
      contactForm: 'Kontaktformular',
      orderService: 'Bestellservice',
      orderServiceTelephone: {
        DE: '0800-9564956',
        AT: '0800-8809400',
      },
      orderServiceEmail: 'bestellungen@wehrfritz.com',
    },
    copyright: '© {{year}} - Habermaass GmbH und Co. KG - gehört zur Habermaass Firmenfamilie',
    shop: {
      catalog: {
        headline: 'Kataloge & Broschüren',
        text1: 'JETZT ANFORDERN ODER HERUNTERLADEN',
        text2: 'Online blåttern',
      },
      payment: {
        headline: 'Unsere Zahlarten',
      },
      secureShopping: {
        headline: 'Sicheres Einkaufen',
        text1: 'Sichere Zahlung mit SSL-Verschlüsselung',
      },
      newsletter: {
        headline: 'Newsletter',
        text1: 'Zur Anmeldung',
        text2:
          'Lassen Sie sich informieren über alle Neuheiten Ihrer Branche und Ideen aus der Praxis!',
      },
    },
    orderInformation: {
      heading: 'Bestell-Hinweise',
      text1: 'Kein Mindestbestellwert',
      text2: 'Bitte beachten Sie, dass die Artikel in Ihrem Warenkorb nicht reserviert sind',
    },
    hints: {
      heading: 'Hinweise',
      text1: 'Alle Angabem in EUR, inkl. MwSt.',
      text2: 'zzgl. Versand- und Servicekosten',
    },
  },
  habaEmptyCategory: {
    websiteTitle: 'Alle Produkte',
    seoTitle: 'Online Shop Wehrfritz | Entdecke innovative premium Produkte',
    seoDescription:
      'Wehrfritz steht für individuelle Lösungen, die Mehrwert stiften ➽ Ihr Komplettausstatter für Krippe, Kindergarten & Schule ➽ Alle Produkte entdecken!',
  },
  countdownBanner: {
    label: 'Noch:',
    days: 'Tage',
    day: 'Tag',
    hours: 'Std',
    minutes: 'Min',
    seconds: 'Sek',
    daysShort: 'D',
    hoursShort: 'H',
    minutesShort: 'M',
    secondsShort: 'S',
  },
  blogPage: {
    pageLinksQuestion: 'Welche Themen interessieren Sie?',
  },
  postalCode: {
    label: 'Suche nach Postleitzahl',
    placeholder: 'Postleitzahl',
    error: 'Bitte geben Sie eine gültige Postleitzahl ein',
    button: 'Suchen',
    info: 'Geben Sie Ihre Postleitzahl ein, um die zuständige Fachberater:in zu finden.',
    responsible: 'Zuständig für {{ city }}',
    phone: 'Tel: {{ phone }}',
    contactNotFound: 'Die Region um {{ city }} ist aktuell nicht besetzt. Den Kontakt zur vertretenden Fachberatung erfahren Sie über unseren Innendienst'
  }
};
